import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=1f2c2aa6&scoped=true&"
import script from "./Categories.vue?vue&type=script&lang=js&"
export * from "./Categories.vue?vue&type=script&lang=js&"
import style0 from "./Categories.vue?vue&type=style&index=0&id=1f2c2aa6&lang=scss&scoped=true&"
import style1 from "./Categories.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2c2aa6",
  null
  
)

export default component.exports